window.pixelpoint.settings = {
    relatedAjaxUrl: "/index.php?action=getRelatedPois&type=1732176051",
    highlightSections: [
        "ubernachten",
        "wasser",
        "aktiv-natur",
        "essen-trinken",
        "wellness",
        "einkaufserlebnisse",
        "kultur",
        "top-angebote",
        "weitere-informationen",
        "sonstige-kategorien",
        "default"
    ],
    apiUrl: 'https://api.tmb.pixelpoint.biz/api/'
}